import type * as Blockly from 'blockly/core';
import { expr, resolveBoard } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['analog_max'] = function (block: Blockly.Block): [string, number] {
        const board = resolveBoard(block);
        return expr(board === 'blue' ? '4095' : '1023');
    };
}
